import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    table: createTableState(),
    filterData: undefined,
})

// getters
const getters = {}

// actions
const actions = {
    // get records
    async get({state, commit}, {page, filterData, append} = {}) {
        if (!append) commit('setLoading', true)

        state.filterData = filterData

        let params = {
            page: page?.current ?? 1,
            page_limit: page?.pageSize ?? 24,
        }

        if (state.filterData) {
            params = {...params, ...state.filterData}
        }

        try {
            const res = await this._vm.axios.get(this._vm.endpoint.get('trash'), {
                params: params
            })

            const {data, meta} = res.data

            if (append) {
                commit('appendTableData', data)
            } else {
                commit('updateTableData', data)
            }

            commit('updatePagination', normalizePagination(meta))

            return data
        } finally {
            if (!append) commit('setLoading', false)
        }
    },

    // recover records
    async recover(_, {id}) {
        const successRecovered = []

        if (id.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
            return successRecovered
        }

        for (let i = 0; i < id.length; i++) {
            // API kurtarmayı GET ile bekliyor (eski paneldeki kullanım da böyle)
            const {data} = await this._vm.axios.get(this._vm.endpoint.get('trash_recover') + '/' + id[i])

            if (data.status) {
                successRecovered.push(id[i])
            } else {
                this._vm.$message.error(data.message)
            }
        }

        return successRecovered
    },

    // permanently delete records
    async delete(_, {id}) {
        const successDeleted = []

        if (id.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
            return successDeleted
        }

        for (let i = 0; i < id.length; i++) {
            const {data} = await this._vm.axios.delete(this._vm.endpoint.get('trash') + '/' + id[i])

            if (data.status) {
                successDeleted.push(id[i])
            } else {
                this._vm.$message.error(data.message)
            }
        }

        return successDeleted
    },

    // refresh records
    refresh({state, dispatch}) {
        dispatch('get', {
            page: state.table.pagination,
            filterData: state.filterData,
        })
    },
}

// mutations
const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateTableData(state, data) {
        state.table.data = data
    },
    appendTableData(state, data) {
        state.table.data = [...state.table.data, ...data]
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
